import { render, staticRenderFns } from "./MyShoppingOrderInfo.vue?vue&type=template&id=284a4156&"
import script from "./MyShoppingOrderInfo.vue?vue&type=script&lang=js&"
export * from "./MyShoppingOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports